import { DataGrid } from '@mui/x-data-grid-premium';
import React from 'react';

class RoleModuleTable extends React.Component {
	constructor(props) {
		super(props);
		this._columns = [
			{
				key: 'Module',
				name: 'Module',
				width: 200,
				resizable: false
			}
		]
		this.state = {
			rows: this.props?.data,
			selectedIndexes: []
		};
		this.onRowsSelected = this.onRowsSelected.bind(this);
		this.onRowsDeselected = this.onRowsDeselected.bind(this);
	}
	rowGetter(item) {
		return item?.Id
	}

	onRowsSelected = (rows) => {
		this.setState({ selectedIndexes: this.state.selectedIndexes.concat(rows.map(r => r.rowIdx)) });
		let updateJson = this.props.scope.state.json;
		rows.forEach((r, i) => {
			rows[i].row.Permissions = "11111111";
		});
		this.props.scope.state.json = updateJson;

	};
	onRowsDeselected = (rows) => {
		let rowIndexes = rows.map(r => r.rowIdx);
		this.setState({ selectedIndexes: this.state.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1) });
		let updateJson = this.props.scope.state.json;
		rows.forEach((r, i) => {
			rows[i].row.Permissions = "00000000";
		});
		this.props.scope.state.json = updateJson;
	};

	render() {
		return (
			<DataGrid
				isRowSelectable={false}
				columns={this._columns}
				rows={this.state.rows}
				cellClass="customGrid"
				getRowId={this.rowGetter.bind(this)}
				hideFooter={true}
				rowsCount={this.state.rows ? this.state.rows.length : 0}
				rowHeight={50}
				minHeight={400}
				rowScrollTimeout={200}
			/>);
	}
}

export default RoleModuleTable;